import { isDefined } from "../utils";
import { HHV as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period } = options;

    if (!data || data.length < period) {
      return [];
    }

    const len = data.length;
    const results = new Array(len);

    for (let i = 0; i < len; i++) {
      if (i < period - 1) {
        results[i] = undefined;
        continue;
      }

      let high = -Infinity;

      // Look back over the period
      for (let j = i - period + 1; j <= i; j++) {
        if (j < 0 || !data[j]) continue;

        if (isDefined(data[j].high)) {
          high = Math.max(high, data[j].high);
        }
      }

      results[i] = high !== -Infinity ? high : undefined;
    }

    return results;
  }

  calculator.undefinedLength = function () {
    const { period } = options;
    return period - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
